import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-processing-dialog",
  templateUrl: "./processing-dialog.component.html",
  styleUrls: ["./processing-dialog.component.scss"]
})
export class ProcessingDialogComponent implements OnInit
{

  dialogText: string;

  constructor(
    public dialogRef: MatDialogRef<ProcessingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data,
  )
  {
    this.dialogText = data;
  }

  ngOnInit(): void
  {
  }

}
